let Base64 = require('js-base64').Base64;
import { Loading } from 'element-ui'

//获取sessionStorage存储数据
export const getSession = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

//设置sessionStorage存储数据
export const setSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

//删除sessionStorage存储数据
export const delSession = (name) => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}


// 将对象拼接成字符串
export const objToStr = function (val) {
  if (val) {
    let params = '';
    for (let x in val) {
      if (val[x]) {
        params += `${x}=${val[x]}&`
      }
    }
    params = params.substr(0, params.length - 1);
    return params
  }
}

// 防抖
export const _debounce = function (fn, delay) {
  var delay = delay || 500;
  var timer;
  return function () {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}

// 有+号，url会转成空格，所以需要把+号转成%2B,之后对比获取的时候再url中的加号转成%2B
export const dealData = function (data) {
  for (let item of data) {
    if (item.list && item.list.length > 0) {
      dealData(item.list)
    }
    if (item.path && item.path.endsWith('page')) {
      item.path = ('/iframe?path=' + Base64.encode((item.path)).replace(/\+/g,'%2B'));
      // item.path = '/iframe?path=' + item.path;
    }
  }
}


export const getNowFormatDate = function () {
  let date = new Date();
  var seperator1 = '-';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  if (month >= 1 && month <= 9) {
    month = '0' + month;
  }
  var currentdate = year + '年' + month + '月';
  return currentdate;
}


let loading , timer , needLoadingRequestCount = 0;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: 'Loading...',
    spinner: 'el-icon-loading',
    background: 'rgba(255,255,255,.5)'
  })
}

//打开loading
export function showFullScreenLoading(time = 300) {
  if (needLoadingRequestCount === 0) {
    if(timer) clearTimeout(timer);
    timer = setTimeout(()=>{ startLoading() }, time);
  }
  needLoadingRequestCount++
}

//关闭loading
export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    if(timer) clearTimeout(timer);
    setTimeout(()=>{
      if(loading) loading.close()
    }, 300)
  }
}

